import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LinkItem } from '@app/shared/interfaces';

@Component({
  selector: 'app-link-list',
  templateUrl: './link-list.component.html',
  styleUrls: ['./link-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkListComponent {
  links = input.required<LinkItem[]>();
}
